export const createSearchParams = (
    init:
        | string
        | readonly (readonly [string, string])[]
        | Record<string, string | readonly string[]>
        | URLSearchParams,
): URLSearchParams => {
    if (typeof init === 'string' || init instanceof URLSearchParams || Array.isArray(init)) {
        return new URLSearchParams(init as string | string[][] | URLSearchParams);
    }

    return new URLSearchParams(
        Object.entries(init).flatMap(([key, value]) =>
            Array.isArray(value) ? value.map((entry) => [key, entry]) : [[key, value]],
        ),
    );
};

export const generatePath = (pattern: string, params: Readonly<Record<string, string | null | undefined>>): string => {
    return pattern
        .split('/')
        .map((segment) => {
            if (!segment.startsWith(':')) return segment;
            const optional = segment.endsWith('?');
            const name = segment.slice(1, optional ? -1 : undefined);
            const value = params[name];
            if (value === null || value === undefined) {
                if (optional) return '';
                throw new Error(`Missing ":${name}" parameter for path "${pattern}"`);
            }
            return encodeURIComponent(value);
        })
        .filter((segment, index) => index === 0 || segment !== '')
        .join('/');
};
